import React from 'react';
import { Linking, Text, View } from 'react-native';
import { markdownBlocks, markdownInline } from '../logic/markdown';
import { font, spacing, usePalette } from '../theme';

/** Text-only rendering: no HTML, embedded images or arbitrary URL schemes. */
export default function Markdown({ children, color }: { children: string; color?: string }) {
  const p = usePalette();
  return <View style={{ gap: spacing.xs }}>
    {markdownBlocks(children).map((block, i) => <Text key={i} selectable
      accessibilityRole={block.kind === 'heading' ? 'header' : undefined}
      style={{ color: color ?? p.text, fontSize: block.kind === 'heading' ? font.headline : font.body,
        lineHeight: 24, fontWeight: block.kind === 'heading' ? '700' : '400',
        ...(block.kind === 'quote' ? { borderLeftWidth: 3, borderLeftColor: p.tint, paddingLeft: spacing.m } : {}),
        ...(block.kind === 'code' ? { fontFamily: 'monospace', backgroundColor: p.card, padding: spacing.s } : {}) }}>
      {block.kind === 'code' ? block.text : markdownInline(block.text).map((part, j) => <Text key={j}
        accessibilityRole={part.href ? 'link' : undefined}
        onPress={part.href ? () => { Linking.openURL(part.href!).catch(() => {}); } : undefined}
        style={{ fontWeight: part.style === 'strong' ? '700' : undefined,
          fontStyle: part.style === 'emphasis' ? 'italic' : undefined,
          fontFamily: part.style === 'code' ? 'monospace' : undefined,
          color: part.href ? p.tint : color ?? p.text, textDecorationLine: part.href ? 'underline' : undefined }}>
        {part.text}
      </Text>)}
    </Text>)}
  </View>;
}
